import { Box, useTheme } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';

function DiscoverAppPanel() {
  const theme = useTheme();
  const { discoverUserPanel } = useSelector(({ dashboardDiscoverReducer }) => {
    return {
      discoverUserPanel: dashboardDiscoverReducer.discoverUserPanel,
    };
  });
  return (
    <Box
      maxWidth={950}
      width={'100%'}
      border={1}
      display="flex"
      borderColor={theme.palette.buzzBorder}
      p={2}>
      <Box flex={1} borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Parents Registered
        </Box>
        <Box fontSize={36} fontWeight={'fontWeightMedium'}>
          {discoverUserPanel ? discoverUserPanel.users : 0}
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Appointments Facilitated
        </Box>
        <Box
          minWidth={130}
          display={'flex'}
          justifyContent={'center'}
          fontSize={36}
          fontWeight={'fontWeightMedium'}>
          {discoverUserPanel ? discoverUserPanel.appointments : 0}
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        borderRight={`1px solid ${theme.palette.buzzBorder}`}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Admission Forms Sold
        </Box>
        <Box
          minWidth={130}
          display={'flex'}
          justifyContent={'center'}
          fontSize={36}
          fontWeight={'fontWeightMedium'}>
          {/* {discoverUserPanel ? discoverUserPanel.admissions : 0} */}
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" flex={1}>
        <Box mb={1} fontSize={16} color={theme.palette.buzzGreyTextColor}>
          Admissions Generated
        </Box>
        <Box
          minWidth={120}
          fontSize={36}
          display={'flex'}
          justifyContent={'center'}
          fontWeight={'fontWeightMedium'}>
          {discoverUserPanel ? discoverUserPanel.addmission : 0}
        </Box>
      </Box>
    </Box>
  );
}

export default DiscoverAppPanel;
